import React, { useState } from 'react';
import { EngagementForm } from '../components/Engagement/EngagementForm';
import { IntentConfirmation } from '../components/Engagement/IntentConfirmation';
import { CommunityAccess } from '../components/Engagement/CommunityAccess';
export const HowToEngage = () => {
  const [currentStep, setCurrentStep] = useState<'form' | 'intent' | 'community'>('form');
  const [formData, setFormData] = useState({});
  const handleFormSubmit = data => {
    setFormData(data);
    setCurrentStep('intent');
  };
  const handleIntentConfirm = (understood: boolean) => {
    if (understood) {
      setCurrentStep('community');
    } else {
      // If they need more details, we could handle that differently
      // For now, just proceed to community access
      setCurrentStep('community');
    }
  };
  return <div className="pt-20 bg-white min-h-screen" data-id="element-3385" data-mp="1753n6yhvge0z">
      <section className="relative py-16 border-b border-gray-200" data-id="element-3386" data-mp="175vj6afdsdrs">
        <div className="absolute inset-0 z-0" data-id="element-3387" data-mp="126io52ecw0e4">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3388" data-mp="16i6qoll4noze" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3389" data-mp="1benfzj42c9e2"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3390" data-mp="1fgiekfum08o5">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3391" data-mp="1ka4s0a8lkgl0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3392" data-mp="1p8ofif2ua0fh">
              Join The Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3393" data-mp="1u6g7f93hhmjo">
              Join our community and connect with like-minded professionals
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-3394" data-mp="238h341j2k0j8">
        <div className="container mx-auto px-4" data-id="element-3395" data-mp="237ebtshu3w2s">
          <div className="max-w-3xl mx-auto" data-id="element-3396" data-mp="4t2x938ox4an">
            {currentStep === 'form' && <EngagementForm onFormSubmit={handleFormSubmit} data-id="element-3397" data-mp="4uxh0e886qd5" />}
            {currentStep === 'intent' && <IntentConfirmation onConfirm={handleIntentConfirm} data-id="element-3398" data-mp="8vzm3botpwn1" />}
            {currentStep === 'community' && <CommunityAccess userLocation={formData.location || ''} data-id="element-3399" data-mp="1c6wyje6di4kd" />}
          </div>
        </div>
      </section>
    </div>;
};